"use client";

import React, { useState } from 'react';
import Image from 'next/image';
import MenuSidebar from '@/app/components/menuSidebar';

const Turnnel: React.FC = () => {
    const fixedChecked = true;
    const [hoveredImage, setHoveredImage] = useState<number | null>(null);

    const handleMouseEnter = (index: number) => {
        setHoveredImage(index);
    };

    const handleMouseLeave = () => {
        setHoveredImage(null);
    };

    const DownloadClickHandler = () => {
        window.open('/doc/turnalSystemDocument.pdf', '_blank'); 
    }

    return (
        <div className='wrapper max-w-10xl mx-auto bg-white'>
            <div className='
                max-w-7xl mx-auto p-6 bg-white shadow-md rounded-lg
                2xl:max-w-2xl
                lg:max-w-lg
                md:max-w-md
                sm:max-w-sm
                flex
                flex-col lg:flex-row gap-6
            '>
                <div className='flex-1'>
                    <h1 className="text-3xl font-bold mb-4">구성도</h1>
                    <div className="mb-6 text-gray-700">
                        환경변화가 빈번한 장소에 통신망을 이용한 사고검출(사고구간, 사고유형)과 지역 내의 설비상태, 주변환경(영상, 풍향/풍속, 온도/습도, 강우량, 강설량)에 대한 정보 등을 실시간으로 전송하여 주변환경의 감시와 유지보수를 신속하고 원활하게 하기 위한 감시 시스템입니다.
                    </div>

                    <div className="mb-6">
                        <Image
                            src="/contents/image/turnnelDiagram.png"
                            className="w-full max-w-screen-lg h-auto object-cover rounded-lg shadow-md"
                            alt="Tunnel Diagram"
                            width={1200}
                            height={800}
                        />
                    </div>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">검증된 시스템</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '한국 도로 공사 BMT 시험 인증.',
                            '사고 자동 감지 S/W GS 인증.'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">실시간 상황 인식</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '다양한 유고 상황 검출 및 경보 발생',
                            '터널 내 특정동작 (정지차량, 역주향, 낙하물, 보행자 등) 인식',
                            '차량 흐름 감지 / 사고 영상 저장 및 검색 가능'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">신속한 초기 대응 조치</h2>
                    <ul className="list-none space-y-4">
                        {[
                            'CCTV 영상 통합정보를 이용 궤적 및 위치 추적 시스템 적용.',
                            '유고상황 시 경보 발생, 사고 현장 실시간 영상 모니터링',
                            '위치정보 추적을 통한 신속하고 정확한 상황 파악과 초기 대응이 가능.'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">정확한 시스템 구현</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '최적의 검출 기술 적용과 시스템 학습효과로 오검지 및 과검지를 최소화.'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">이벤트 경보</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '검출된 유고상황이 사고로 확정되었을 경우, 라디오/터널 내 스피커를 이용하여 경보상황을 알림.',
                            '2차사고를 미연에 방지 가능.'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">딥러닝 기술 유고검출 특징</h2>
                    <ul className="list-none space-y-4 border border-blue-500 p-5 rounded-lg">
                        {[
                            '딥러닝 기술을 이용하여, 보행자, 차량, 화재(화염, 연기) 등 객체 검출 및 분류',
                            '기존 배경추정 기반의 검출 방법에 비해 조명 변화에 강건하며, 오검지율이 적음',
                            '다양한 환경에서 추출한 데이터를 이용한 학습을 통해, 높은 검지율 제공',
                            '원거리 검지에는 먼저 배경추정 기술을 통해 객체를 추출하고 딥러닝 분류기를 이용하여 검증하는 방법을 사용',
                            '다양한 돌발상황(정지차량, 보행자, 역주행, 낙하물 등)과 화재사고 인식 및 모니터링을 통한 신속한 사고대처 가능'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">기능</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '영상분석 / 사고감지: 영상 실시간 분석, 주장치 1대 동시 8채널 이상 영상 분석, 보행자, 정치차량, 역주행차량, 낙하물, 연기, 교통정체 감지, 단일 및 복합 사고 감지',
                            '알람 / 이벤트 관리: 사고발생 시 유고 알람, 이벤트발생 시 팝업창 알람, 설정된 이벤트 시나리오대로 신속한 유고상황 대응',
                            '사고현장 위치정보 추적 기능',
                            '통합관제 / 관리: 다채널 영상 관제, 다양한 설정 (검지영역 설정, 사용자 등록 및 권한 설정, 영상녹화설정), 상태/이벤트 관리 및 장애보고',
                            '저장 / 검색 / 연계: 유고영상 저장 및 검색, 이벤트 로그 저장, 터널 영상설비, 연기설비 인터페이스',
                            '통계 / 보고서 작성: 저장된 검출 이벤트를 바탕으로 손쉽게 통계보고서 작성'
                        ].map((text, index) => (
                            <li key={index + 9} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                {text}
                            </li>
                        ))}
                    </ul>
                
                    <h2 className="text-2xl font-semibold mb-4 mt-10">첨부 이미지</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {[...Array(4).keys()].map((i) => (
                            <div
                                key={i}
                                className="relative overflow-hidden rounded-lg border border-gray-200 shadow-md"
                                onMouseEnter={() => handleMouseEnter(i)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Image
                                    src={`/contents/image/attachment${i + 1}.png`}
                                    className="w-full h-auto object-cover rounded-lg transition-transform duration-300 ease-in-out"
                                    alt={`Attachment ${i + 1}`}
                                    style={{
                                        transform: hoveredImage === i ? 'scale(1.1)' : 'scale(1)',
                                    }}
                                    width={1200} 
                                    height={800} 
                                />
                            </div>
                        ))}
                    </div>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">영상 유고 시스템</h2>
                </div>

                <div className='h-auto p-30px'>
                    <MenuSidebar category="ITS" />
                    <div className='bg-gray-100 p-6 rounded-lg mt-10'>
                        <h2 className="text-2xl font-semibold mb-4">카달로그</h2>
                        <button
                            onClick={DownloadClickHandler}
                            className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            PDF 다운로드
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Turnnel;
